/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppUsersRouteImport } from './routes/_app.users'
import { Route as AppTokensRouteImport } from './routes/_app.tokens'
import { Route as AppSessionsRouteImport } from './routes/_app.sessions'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppOutboundWebhooksRouteImport } from './routes/_app.outbound-webhooks'
import { Route as AppGroupsRouteImport } from './routes/_app.groups'
import { Route as AppDevicesRouteImport } from './routes/_app.devices'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppAuditRouteImport } from './routes/_app.audit'
import { Route as AppAddressBooksRouteImport } from './routes/_app.address-books'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppTokensRoute = AppTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AppRoute,
} as any)
const AppSessionsRoute = AppSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppOutboundWebhooksRoute = AppOutboundWebhooksRouteImport.update({
  id: '/outbound-webhooks',
  path: '/outbound-webhooks',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsRoute = AppGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesRoute = AppDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAddressBooksRoute = AppAddressBooksRouteImport.update({
  id: '/address-books',
  path: '/address-books',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/address-books': typeof AppAddressBooksRoute
  '/audit': typeof AppAuditRoute
  '/dashboard': typeof AppDashboardRoute
  '/devices': typeof AppDevicesRoute
  '/groups': typeof AppGroupsRoute
  '/outbound-webhooks': typeof AppOutboundWebhooksRoute
  '/profile': typeof AppProfileRoute
  '/sessions': typeof AppSessionsRoute
  '/tokens': typeof AppTokensRoute
  '/users': typeof AppUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/address-books': typeof AppAddressBooksRoute
  '/audit': typeof AppAuditRoute
  '/dashboard': typeof AppDashboardRoute
  '/devices': typeof AppDevicesRoute
  '/groups': typeof AppGroupsRoute
  '/outbound-webhooks': typeof AppOutboundWebhooksRoute
  '/profile': typeof AppProfileRoute
  '/sessions': typeof AppSessionsRoute
  '/tokens': typeof AppTokensRoute
  '/users': typeof AppUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/address-books': typeof AppAddressBooksRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/devices': typeof AppDevicesRoute
  '/_app/groups': typeof AppGroupsRoute
  '/_app/outbound-webhooks': typeof AppOutboundWebhooksRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/sessions': typeof AppSessionsRoute
  '/_app/tokens': typeof AppTokensRoute
  '/_app/users': typeof AppUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/address-books'
    | '/audit'
    | '/dashboard'
    | '/devices'
    | '/groups'
    | '/outbound-webhooks'
    | '/profile'
    | '/sessions'
    | '/tokens'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/address-books'
    | '/audit'
    | '/dashboard'
    | '/devices'
    | '/groups'
    | '/outbound-webhooks'
    | '/profile'
    | '/sessions'
    | '/tokens'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/address-books'
    | '/_app/audit'
    | '/_app/dashboard'
    | '/_app/devices'
    | '/_app/groups'
    | '/_app/outbound-webhooks'
    | '/_app/profile'
    | '/_app/sessions'
    | '/_app/tokens'
    | '/_app/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tokens': {
      id: '/_app/tokens'
      path: '/tokens'
      fullPath: '/tokens'
      preLoaderRoute: typeof AppTokensRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sessions': {
      id: '/_app/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof AppSessionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outbound-webhooks': {
      id: '/_app/outbound-webhooks'
      path: '/outbound-webhooks'
      fullPath: '/outbound-webhooks'
      preLoaderRoute: typeof AppOutboundWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups': {
      id: '/_app/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AppGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices': {
      id: '/_app/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AppDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/address-books': {
      id: '/_app/address-books'
      path: '/address-books'
      fullPath: '/address-books'
      preLoaderRoute: typeof AppAddressBooksRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAddressBooksRoute: typeof AppAddressBooksRoute
  AppAuditRoute: typeof AppAuditRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDevicesRoute: typeof AppDevicesRoute
  AppGroupsRoute: typeof AppGroupsRoute
  AppOutboundWebhooksRoute: typeof AppOutboundWebhooksRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSessionsRoute: typeof AppSessionsRoute
  AppTokensRoute: typeof AppTokensRoute
  AppUsersRoute: typeof AppUsersRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAddressBooksRoute: AppAddressBooksRoute,
  AppAuditRoute: AppAuditRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDevicesRoute: AppDevicesRoute,
  AppGroupsRoute: AppGroupsRoute,
  AppOutboundWebhooksRoute: AppOutboundWebhooksRoute,
  AppProfileRoute: AppProfileRoute,
  AppSessionsRoute: AppSessionsRoute,
  AppTokensRoute: AppTokensRoute,
  AppUsersRoute: AppUsersRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
